import { Routes, Route, useLocation } from 'react-router-dom';
import { useSessionUser } from 'shared/store/session';

import Login from 'Pages/Login';

import PaginaPadrao from 'shared/components/PaginaPadrao';
import {
  NotFound,
  NotPermission,
  WorkflowCampanha,
  OrganizationSeletion,
  ListagemDeCampanhas,
  ListagemDeWorkflows,
  DetalheDeWorkflows,
  ListagemDeDadosVariaveis,
  ListagemDeLogsDadosVariaveis,
  DetalheDeDadosVariaveis,
  ListagemDeOrganizacao,
  ListagemLogsDeOrganizacao,
  DetalheDeOrganizacao,
  LoginToken,
  ListagemDeGrupoTeste,
  ListagemDeLogsGrupoTeste,
  ListagemDeLogsDestinatarioGrupoTeste,
  DetalheDeGrupoTeste,
  ListagemGrupoTesteDestinatario,
  DetalheDeGrupoTesteDestinatario,
  ListagemDeUsuario,
  DetalheDeUsuario,
  ListagemDeUsuarioRole,
  ListagemDeUsuarioOrg,
  DetalheDeUsuarioOrg,
  ListagemDeOrgForCon,
  DetalheOrgFornecedora,
  ListagemLogsChaveValor,
  ListagemDeEnvio,
  DetalheDeEnvio,
  ListagemLogsDeEnvio,
  ListagemLogsDeWorkflow,  
  ListagemLogsUsuarioOrg,
  ListagemLogsDeOrgFornecedora,
  ListagemDeComunicacao,
  DetalheDeComunicacao,
  ChangePassword,
  ChangeNewPassword,
  ConfiguracaoCrib
  

} from 'Pages';
import { useHasPermissionPath } from 'shared/hooks';
import { DetalheDeUsuarioRole } from 'Pages/Usuario/DetalheDeUsuarioRole';
import { ListagemDeChaveValor } from 'Pages/ChaveValor/ListagemDeChaveValor';
import { DetalheDeChaveValor } from 'Pages/ChaveValor/DetalheDeChaveValor';

import { ListagemDeLogsComunicacao } from 'Pages/Comunicação/ListagemDeLogsComunicacao';
import { ListagemLogsDeUsuario } from 'Pages/Usuario/ListagemLogsDeUsuario';
import { ListagemLogsDeUsuarioRole } from 'Pages/Usuario/ListagemLogsDeUsuarioRole';

// import { DetalheDeChaveValor } from 'Pages/ChaveValor/DetalheDeChaveValor';

export default function AppRouter() {
  const user = useSessionUser();
  const location = useLocation();
  const hasPermition = useHasPermissionPath(location.pathname);
  //console.log('hasPermition',location.pathname, ' - ' , hasPermition);
  
  return (
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/logintoken/:token' element={<LoginToken />} />
      <Route path='/organizationseletion' element={user ? <OrganizationSeletion /> : <Login />} />
      <Route path='/changepassword' element={user ? <ChangePassword /> : <Login />}  />
      <Route path='/changenewpassword' element={user ? <ChangeNewPassword /> : <Login />}  />
      <Route path='/' element={<PaginaPadrao />} >
        <Route path='campanha/listagem' element={hasPermition ? <ListagemDeCampanhas /> : <NotPermission />} />
        <Route path='organizacao/listagem' element={hasPermition ? <ListagemDeOrganizacao /> : <NotPermission />} />
        <Route path='organizacao/listagem/logs' element={hasPermition ? <ListagemLogsDeOrganizacao /> : <NotPermission />} />
        <Route path='organizacao/detalhe/:id' element={hasPermition ? <DetalheDeOrganizacao /> : <NotPermission />} />
        <Route path='workflow/listagem' element={hasPermition ? <ListagemDeWorkflows /> : <NotPermission />} />
        <Route path='workflow/detalhe/:id' element={hasPermition ? <DetalheDeWorkflows /> : <NotPermission />} />
        <Route path='workflow/detalhe/:id/flow' element={hasPermition ? <WorkflowCampanha /> : <NotPermission />} />
        <Route path='workflow/listagem/logs' element={hasPermition ? <ListagemLogsDeWorkflow /> : <NotPermission />} />
        <Route path='dadosvariaveis/listagem' element={hasPermition ? <ListagemDeDadosVariaveis /> : <NotPermission />} />
        <Route path='dadosvariaveis/listagem/logs' element={hasPermition ? <ListagemDeLogsDadosVariaveis /> : <NotPermission />} />
        <Route path='dadosvariaveis/detalhe/:id' element={hasPermition ? <DetalheDeDadosVariaveis /> : <NotPermission />} />
        <Route path='grupoteste/listagem/' element={<ListagemDeGrupoTeste />} />
        <Route path='grupoteste/listagem/logs' element={<ListagemDeLogsGrupoTeste />} />
        <Route path='grupoteste/listagem/logsDestinatario' element={<ListagemDeLogsDestinatarioGrupoTeste />} />
        <Route path='grupoteste/detalhe/:idCanal/:id' element={<DetalheDeGrupoTeste />} />
        <Route path='grupoteste/detalhe/:idCanal/:idGrupoTeste/destinatario' element={hasPermition ? <ListagemGrupoTesteDestinatario /> : <NotPermission />} />
        <Route path='grupoteste/detalhe/:idCanal/:idGrupoTeste/destinatario/:id' element={hasPermition ? <DetalheDeGrupoTesteDestinatario /> : <NotPermission />} />
        <Route path='usuario/listagem/' element={<ListagemDeUsuario />} />
        <Route path='usuario/listagem/logs' element={<ListagemLogsDeUsuario />} />
        <Route path='usuario/detalhe/:id' element={<DetalheDeUsuario />} />
        <Route path='usuario/detalhe/:idUsuario/role' element={<ListagemDeUsuarioRole />} />
        <Route path='usuario/detalhe/:idUsuario/role/:id' element={<DetalheDeUsuarioRole />} />
        <Route path='usuario/role/listagem/logs/:idUsuario' element={<ListagemLogsDeUsuarioRole />} />
        <Route path='usuario/detalhe/:idUsuario/org' element={<ListagemDeUsuarioOrg />} />
        <Route path='usuario/detalhe/:idUsuario/org/:id' element={<DetalheDeUsuarioOrg />} />
        <Route path='usuario/detalhe/:idUsuario/org/log' element={<ListagemLogsUsuarioOrg />} />

        <Route path='configChaveValor/listagem' element={hasPermition ? <ListagemDeChaveValor /> : <NotPermission />} />
        <Route path='configChaveValor/listagem/logs' element={hasPermition ? <ListagemLogsChaveValor /> : <NotPermission />} />
        <Route path='/fornecedora/listagem' element={hasPermition ? <ListagemDeOrgForCon /> : <NotPermission />} />
        <Route path='/org/fornecedora/listagem/logs' element={<ListagemLogsDeOrgFornecedora /> } />
        <Route path='/org/fornecedora/detalhe/:Fornecedora/:Canal' element={<DetalheOrgFornecedora /> } />
        <Route path='/org/fornecedora/detalhe/' element={<DetalheOrgFornecedora /> } />
        <Route path='configChaveValor/detalhe/:id' element={hasPermition ? <DetalheDeChaveValor /> : <NotPermission />} /> 
        <Route path='envio/listagem' element={hasPermition ? <ListagemDeEnvio /> : <NotPermission />} /> 
        <Route path='envio/detalhe/:id/:idCanal' element={<DetalheDeEnvio /> } /> 
        <Route path='envio/detalhe/' element={<DetalheDeEnvio /> } /> 
        
        <Route path='envio/listagem/logs' element={<ListagemLogsDeEnvio /> } /> 
        <Route path='comunicacao/listagem' element={<ListagemDeComunicacao /> } /> 
        <Route path='comunicacao/listagem/logs' element={<ListagemDeLogsComunicacao /> } /> 
        <Route path='comunicacao/detalhe/:id' element={<DetalheDeComunicacao /> } /> 
        <Route path='/crib/listagem' element={<ConfiguracaoCrib /> } /> 


        <Route path='*' element={<NotFound />} />
      </Route>
      
    </Routes>
  );
}